
import  { QRCodeCanvas } from "qrcode.react";
import "./QrWAcode.css";

const whatsappUrl = "http://api.whatsapp.com/send?phone=919372809411&text=Salam&type=phone_number&app_absent=0";

const QrWAcode = () => {
  return (
    <div className="whatsapp-qr-container" data-aos="fade-in">
      <div className="qr-section">
        <QRCodeCanvas value={whatsappUrl} size={200} />
      </div>
      <div className="text-section">
        <h2><img alt="WhatsApp" class="whatsapp-icon" src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" /> <br/> Scan QR to join our WhatsApp group</h2>
      </div>
    </div>
  );
};

export default QrWAcode;
